export default __webpack_public_path__ + "static/media/Preview.dfd942d6.svg";